import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=fff4b1ae&scoped=true"
import script from "./PayWay.vue?vue&type=script&lang=js"
export * from "./PayWay.vue?vue&type=script&lang=js"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=fff4b1ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4b1ae",
  null
  
)

export default component.exports